import { cn } from '~/lib/cn';

// Capitalizes the first letter of a string.
export function capitalize(str: string) {
  return str.charAt(0)?.toUpperCase() + str.slice(1).toLowerCase();
}

export function getNavLinkClassName(
  { isActive }: { isActive: boolean } = { isActive: false },
) {
  return cn(
    'flex items-center gap-xs !border-b-2xs pb-xs duration-300 ease-out border-transparent hover:text-default',
    {
      'border-b-primary-default text-default': isActive,
    },
  );
}
